import './searchResultItem.scss';
import React from 'react';
import {ListGroupItem} from 'react-bootstrap';
import classNames from 'clsx';
import {ProductDocument} from '../../../search-types';
import {useSelectedDocContext} from '../../../search-hooks';
import {ReduxIndexedNormalizedType} from '../../../../app-types';
import {ResultItemViewConfig} from '../../../../config/config-types';
import {BookmarkColumnControl} from './column-controls/bookmark-column-control';
import {ContentColumnControl} from './column-controls/content-column-control';
import {FileTypeColumnControl} from './column-controls/fileType-column-control';
import {openNewDocument, resetResultDetails} from '../../../duck/search-actions';
import {useDispatch} from 'react-redux';
import {DuplicatesColumnControl} from './column-controls/duplicates-column-control';

interface SearchResultItemProps {
    style: React.CSSProperties;
    index: number;
    data: {
        docs: ReduxIndexedNormalizedType<ProductDocument>;
        onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
        resultItemViewConfig: ResultItemViewConfig;
    };
}

export const SearchResultItem = React.memo(({index, style, data}: SearchResultItemProps) => {
    const {docs, onKeyDown, resultItemViewConfig} = data;
    const doc = docs.byKey[docs.allKeys[index]] as ProductDocument;
    const selectedDoc = useSelectedDocContext();
    const isSelected = selectedDoc?.id === doc?.id;
    const dispatch = useDispatch();

    function onItemClicked() {
        if (isSelected) {
            // deselect then
            dispatch(resetResultDetails());
        } else {
            const selection = window.getSelection();
            if (selection?.type !== 'Range') {
                dispatch(openNewDocument(doc));
            }
        }
    }

    return (
        <ListGroupItem
            className={classNames('search-result-item', isSelected && 'selected-doc')}
            onClick={onItemClicked}
            style={style}
        >
            <article onKeyDown={onKeyDown} tabIndex={0}>
                <div className={'document-row'}>
                    <div>
                        <FileTypeColumnControl key={'fileType-column-control-' + doc.id} doc={doc}
                                           resultItemViewConfig={resultItemViewConfig}></FileTypeColumnControl>
                        <DuplicatesColumnControl key={'duplicates-column-control-' + doc.id} doc={doc}
                                           resultItemViewConfig={resultItemViewConfig} isSelected={isSelected}></DuplicatesColumnControl>
                    </div>
                    <ContentColumnControl key={'content-column-control-' + doc.id} doc={doc}
                                          resultItemViewConfig={resultItemViewConfig}></ContentColumnControl>
                    <BookmarkColumnControl key={'bookmark-column-control-' + doc.id} doc={doc}
                                           resultItemViewConfig={resultItemViewConfig}></BookmarkColumnControl>
                </div>
            </article>
        </ListGroupItem>
    );
});
